import { apiFetch } from './api';

// Customer auth API — thin fetch wrapper around /api/customer-auth.
// SEC-06 Phase 5: tokens live in HttpOnly cookies now; apiFetch
// sends `credentials: 'include'` so the customer_session cookie
// travels with every call. The old getCustomerToken/setCustomerToken
// helpers are gone — JS can't (and shouldn't) touch the auth token
// anymore. Logout is a server call that clears the cookie.
//
// 401s are handled by the calling component / AuthContext rather
// than being intercepted globally, because a customer-side 401
// should never kick the user to the admin /login route.

async function request(path, { method = 'GET', body } = {}) {
  const res = await apiFetch(`/api/customer-auth${path}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try { data = await res.json(); } catch { /* no body */ }
  if (!res.ok) {
    const msg = (data && data.error) || `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const customerAuthApi = {
  register: (payload) => request('/register', { method: 'POST', body: payload }),
  login: (payload) => request('/login', { method: 'POST', body: payload }),
  forgot: (payload) => request('/forgot', { method: 'POST', body: payload }),
  reset: (payload) => request('/reset', { method: 'POST', body: payload }),
  verify: (payload) => request('/verify', { method: 'POST', body: payload }),
  me: () => request('/me'),
  updateProfile: (payload) => request('/me', { method: 'PUT', body: payload }),
  orders: () => request('/orders'),
};
